<template lang="pug">
  div(class="content")
    div(class="md-layout md-gutter md-alignment-center-center")
      div(class="custom-div md-layout-item md-size-40 md-medium-size-55 md-xsmall-size-100")
        md-card
          md-card-header(data-background-color="green")
            h4(class="title") New Account Activation
          md-card-content
            div(class="md-layout" style="text-align: center")
              h4(v-if="success") Your account is now activated. Thank you for joining USIT Portal, and we hope you consider becoming a paid USIT member.
                br
                router-link(:to='{name: "Signin"}') Log in now.
              h4(v-else) Sorry, there was an error activating your account. Please try again! For support, please contact technology@usiteam.org.
</template>

<script>
import axios from 'axios';

export default {
    data() {
      return{
        success: false,
      };
    },
    created() {
      axios.get('/api/activate/' + this.$route.params.token)
      .then((response) => {
        if(response.data.error){
            this.success = false;
        } else {
            this.success = true;
        }
      }).catch((err) => {
        console.log(err);
        this.success = false;
      })
    },
}
</script>

<style scoped>
  .custom-div{
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/Activate.vue